
    var riot = require('riot')
    //src: starling/src/tags/right-click-menu.html
riot.tag2('right-click-menu',
  '<ul if="{isImageMenu || isVideoMenu || isFileMenu}" class="floating-menu_list" ref="floatingMenuEl"> <li class="floating-menu_list_title">{isVideoMenu ? \'Video\' : isFileMenu ? \'File\' : \'Image\'}</li> <li if="{isImageMenu || isVideoMenu}" ref="imageSizeMenuItem" class="floating-menu_item" onmouseenter="{openImageSizeMenu}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">photo_size_select_large</i> <span class="floating-menu_label">{isVideoMenu ? \'Video size\' : \'Image size\'}</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> </li> <li if="{(isImageMenu || isVideoMenu || isFileMenu) && isPdfFile}" class="floating-menu_item" onclick="{openLightbox}" onmouseenter="{delayedHideSubMenus}"> <svg class="menu-icon floating-menu_icon"> <use xlink:href="#file-view-icon"></use> </svg> <span class="floating-menu_label">View file in browser</span> </li> <li if="{isImageMenu}" class="floating-menu_item" onclick="{openEditImage}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">edit</i> <span class="floating-menu_label"> {isVideoMenu ? \'Edit video\' : isFileMenu ? \'Edit file\' : \'Edit image\'} </span> </li> <li if="{isImageMenu || isVideoMenu || isFileMenu}" class="floating-menu_item" onclick="{downloadFile}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">cloud_download</i> <span class="floating-menu_label"> {isVideoMenu ? \'Download video\' : isFileMenu ? \'Download file\' : \'Download image\'} </span> </li> <li class="floating-menu_divider"></li> <li if="{isImageMenu || isVideoMenu || isFileMenu}" class="floating-menu_item" onclick="{deleteImage}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">delete</i> <span class="floating-menu_label"> {isVideoMenu ? \'Delete video\' : isFileMenu ? \'Delete file\' : \'Delete image\'} </span> </li> </ul> <ul if="{isPerspectivePointMenu}" class="floating-menu_list" ref="floatingMenuEl"> <li class="floating-menu_list_title" riot-style="background-color: {getPerspectiveColor()};">Perspective selected</li> <li if="{!perspectiveIsActive()}" class="floating-menu_item" onclick="{viewPerspective}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">visibility</i> <span class="floating-menu_label">View perspective</span> </li> <li if="{perspectiveIsActive()}" class="floating-menu_item" onclick="{exitPerspective}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">visibility_off</i> <span class="floating-menu_label">Exit perspective</span> </li> <li class="floating-menu_item" onmouseenter="{summonPerspectiveColorPicker}"> <div class="color-icon-group floating-menu_icon"> <div class="color-picker-toggle-button-swatch" riot-style="background-color: {getPerspectiveColor()}"></div> </div> <span class="floating-menu_label">Color</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <div ref="colorPicker" class="colorPicker"> <color-picker if="{perspectiveColorPickerVisible}" positioning="{colorPickerPosition(\'perspective\')}" colors="{perspectiveColors}" setcolor="{setPerspectiveColor}" onclick="{ignoreClick}" type="tag"></color-picker> </div> </li> <li class="floating-menu_item" onclick="{removePerspective}" onmouseenter="{delayedHideSubMenus}"> <svg class="floating-menu_icon"> <use xlink:href="#delete-icon"></use> </svg> <span class="floating-menu_label">Remove perspective</span> </li> <li class="floating-menu_divider"></li> <li class="floating-menu_item" onmouseenter="{delayedHideSubMenus}" onclick="{openPerspectivesOnboarding}"> <i class="material-icons floating-menu_icon">help</i> <span class="floating-menu_label">What\'s this?</span> </li> </ul> <div if="{isAttributeMenu}" class="floating-menu_list" ref="floatingMenuEl"> <h3 class="floating-menu_list_title">Attribute selected</h3> <menu-item-edit-attribute></menu-item-edit-attribute> <div class="floating-menu_divider"></div> <menu-item-remove-attribute></menu-item-remove-attribute> </div> <ul if="{isNodePerspectiveDotMenu || isNodePerspectiveAnnotationMenu}" class="floating-menu_list" ref="floatingMenuEl"> <li class="floating-menu_list_title" riot-style="background-color: {getPerspectiveColor()};">Perspective selected</li> <li if="{isNodePerspectiveDotMenu}" class="floating-menu_item" onclick="{removeFromPerspectiveView}" onmouseenter="{delayedHideSubMenus}"> <svg class="floating-menu_icon"> <use xlink:href="#delete-icon"></use> </svg> <span class="floating-menu_label">Remove perspective on card</span> </li> <li if="{isNodePerspectiveDotMenu}" class="floating-menu_divider"></li> <li if="{isNodePerspectiveDotMenu && !isAnnotationShowing()}" class="floating-menu_item" onclick="{editPerspectiveAnnotation}" onmouseenter="{delayedHideSubMenus}"> <i class="toolbar-icons perspective-annotation floating-menu_icon"></i> <span class="floating-menu_label">{hasPerspectiveAnnotation() ? \'Edit perspective note\' : \'Add perspective note\'}</span> </li> <li if="{isNodePerspectiveDotMenu && !isAnnotationShowing()}" class="floating-menu_divider"></li> <li if="{(isNodePerspectiveAnnotationMenu || isNodePerspectiveDotMenu) && isAnnotationShowing()}" class="floating-menu_item floating-menu_item--iconless" onclick="{hidePerspectiveAnnotation}" onmouseenter="{delayedHideSubMenus}"> <span class="floating-menu_label">Hide perspective note</span> </li> <li if="{(isNodePerspectiveAnnotationMenu || isNodePerspectiveDotMenu) && hasPerspectiveAnnotation()}" class="floating-menu_item floating-menu_item--iconless" onclick="{deletePerspectiveAnnotation}" onmouseenter="{delayedHideSubMenus}"> <span class="floating-menu_label">Delete perspective note</span> </li> <li if="{(isNodePerspectiveAnnotationMenu || isNodePerspectiveDotMenu) &&         (isAnnotationShowing() || hasPerspectiveAnnotation())}" class="floating-menu_divider"> </li> <li if="{isAnyPerspectiveMenu()}" class="floating-menu_item" onmouseenter="{delayedHideSubMenus}" onclick="{openPerspectivesOnboarding}"> <i class="material-icons floating-menu_icon">help</i> <span class="floating-menu_label">What\'s this?</span> </li> </ul> <div if="{!isImageMenu &&       !isVideoMenu &&       !isFileMenu &&       !isPerspectivePointMenu &&       !isNodePerspectiveDotMenu &&       !isNodePerspectiveAnnotationMenu &&       (isBulkMenu || singleCardMenu || isCanvasOrNodeMenu())}" class="floating-menu_list" ref="floatingMenuEl"> <div if="{isBulkMenu}" class="floating-menu_list_title"> <span if="{canvas.getSelectedNodes().length > 0 && canvas.getSelectedLinks().length == 0}"> {canvas.getSelectedNodes().length} card{canvas.getSelectedNodes().length > 1 ? \'s\': \'\'} </span> <span if="{canvas.getSelectedNodes().length > 0 && canvas.getSelectedLinks().length > 0}"> {canvas.getSelectedNodes().length} card{canvas.getSelectedNodes().length > 1 ? \'s\': \'\'} and {canvas.getSelectedLinks().length} relationship{canvas.getSelectedLinks().length > 1 ? \'s\': \'\'} </span> <span if="{canvas.getSelectedLinks().length > 0 && canvas.getSelectedNodes().length == 0}"> {canvas.getSelectedLinks().length} relationship{canvas.getSelectedLinks().length > 1 ? \'s\': \'\'} </span> </div> <section if="{isCanvasMenu() && !showCardOptions() && !showRelationshipOptions() && this.canEdit()}"> <menu-item-create-card></menu-item-create-card> <menu-item-create-region></menu-item-create-region> <menu-item-create-line></menu-item-create-line> <div class="floating-menu_divider"></div> </section> <section if="{isBulkMenu || singleCardMenu || isCanvasOrNodeMenu() || canComment()}"> <menu-item-add-part if="{singleCardMenu}" onmouseenter="{delayedHideSubMenus}"></menu-item-add-part> <menu-item-add-summary if="{singleCardMenu}" onmouseenter="{delayedHideSubMenus}"></menu-item-add-summary> <menu-item-add-comment if="{canComment()}"></menu-item-add-comment> <div class="floating-menu_divider" if="{!canvas.canCommentOnly() || isCanvasMenu()}"></div> </section> <section if="{this.canEdit() && (showCopy() || showCut() || showSelectAll() || showPaste() || showCardOptions())}"> <li if="{showCopy()}" class="floating-menu_item" onclick="{copy}" onmouseenter="{delayedHideSubMenus}"> <i class="fa fa-copy floating-menu_icon"></i> <span class="floating-menu_label">Copy</span> <span class="floating-menu_shortcut">{isMac ? \'⌘C\' : \'Ctrl+C\'}</span> </li> <li if="{showCut()}" class="floating-menu_item" onclick="{cut}" onmouseenter="{delayedHideSubMenus}"> <i class="fa fa-cut floating-menu_icon"></i> <span class="floating-menu_label">Cut</span> <span class="floating-menu_shortcut">{isMac ? \'⌘X\' : \'Ctrl+X\'}</span> </li> <menu-item-select-all if="{showSelectAll()}" onmouseenter="{delayedHideSubMenus}"></menu-item-select-all> <menu-item-paste if="{showPaste()}" onmouseenter="{delayedHideSubMenus}"></menu-item-paste> <menu-item-duplicate if="{showCardOptions()}"></menu-item-duplicate> <div class="floating-menu_divider"></div> </section> <section if="{this.canEdit() && (         showCardOptions() ||         (nodeTag && !(canvas.selectedElements.length > 1) && !showPartsOptions() && !isFreehandMenu)       )}"> <menu-item-card-style if="{showCardOptions()}"></menu-item-card-style> <menu-item-images if="{nodeTag && !(canvas.selectedElements.length > 1) && !showPartsOptions() && !isFreehandMenu && this.canEdit()}" onmouseenter="{delayedHideSubMenus}"></menu-item-images> <div class="floating-menu_divider"></div> </section> <section if="{(canvas.isFeatureEnabled(\'attributes\') || canvas.isFeatureEnabled(\'perspectives\')) &&       this.canEdit() && (         showCardOptions() ||         showRelationshipOptions() && !showPartsOptions()       )}"> <menu-item-attribute-editor if="{canvas.isFeatureEnabled(\'attributes\') && showCardOptions()}"></menu-item-attribute-editor> <menu-item-perspectives if="{canvas.isFeatureEnabled(\'perspectives\') && (showCardOptions() || showRelationshipOptions()) && !showPartsOptions()}"></menu-item-perspectives> <div class="floating-menu_divider"></div> </section> <section if="{canvas.isFeatureEnabled(\'presentation\') && showCardOptions() && !showPartsOptions()}"> <menu-item-create-waypoint onmouseenter="{delayedHideSubMenus}"></menu-item-create-waypoint> <div class="floating-menu_divider"></div> </section> <section if="{showCardOptions()}"> <menu-item-link-to-selection onmouseenter="{delayedHideSubMenus}"></menu-item-link-to-selection> <menu-item-export></menu-item-export> <div class="floating-menu_divider"></div> </section> <section if="{this.canEdit() && (         showGroupSelection() ||         showUngroupSystem() ||         showArrangeOption() ||         showLayoutOption() ||         showPopOut() ||         showPopIn() ||         showDetachPart()       )}"> <menu-item-group-selection if="{showGroupSelection()}" onmouseenter="{delayedHideSubMenus}"></menu-item-group-selection> <menu-item-ungroup-system if="{showUngroupSystem()}" onmouseenter="{delayedHideSubMenus}"></menu-item-ungroup-system> <menu-item-arrange if="{showArrangeOption()}"></menu-item-arrange> <menu-item-layout if="{showLayoutOption()}"></menu-item-layout> <menu-item-pop-parts if="{showPopOut() || showPopIn()}" inorout="{showPopIn() ? \'in\' : \'out\'}" onmouseenter="{delayedHideSubMenus}"></menu-item-pop-parts> <menu-item-detach-part if="{showDetachPart()}" onmouseenter="{delayedHideSubMenus}"></menu-item-detach-part> <div if="{showRelationshipOptions() ||           showCreateRelationshipCard() ||           showDetachRelationshipCard() ||           (showCardOptions() && !showPartsOptions())}" class="floating-menu_divider"> </div> </section> <section if="{this.canEdit() && (         showRelationshipOptions() ||         showCreateRelationshipCard() ||         showDetachRelationshipCard()       )}"> <menu-item-link-direction if="{showRelationshipOptions()}"></menu-item-link-direction> <menu-item-create-relationship-card if="{showCreateRelationshipCard()}" onmouseenter="{delayedHideSubMenus}"></menu-item-create-relationship-card> <menu-item-relationship-style if="{showRelationshipOptions()}"></menu-item-relationship-style> <menu-item-straighten-line if="{showRelationshipOptions()}" onmouseenter="{delayedHideSubMenus}"></menu-item-straighten-line> <menu-item-detach-relationship-card if="{showDetachRelationshipCard()}" onmouseenter="{delayedHideSubMenus}"></menu-item-detach-relationship-card> <div class="floating-menu_divider"></div> </section> <section if="{this.canEdit() && (showCardOptions() || showRelationshipOptions()) && !showPartsOptions()}"> <menu-item-delete onmouseenter="{delayedHideSubMenus}"></menu-item-delete> <div if="{isCanvasMenu()}" class="floating-menu_divider"></div> </section> <section if="{isCanvasMenu()}"> <menu-item-settings></menu-item-settings> <li class="floating-menu_item" onmouseenter="{delayedHideSubMenus}" onclick="{openUserGuide}" data-track="Right Click Menu" data-track-action="Help"> <i class="material-icons floating-menu_icon">help</i> <span class="floating-menu_label">Get help</span> </li> <li if="{canvasIsEmpty()}" class="floating-menu_item floating-menu_item--iconless" onmouseenter="{delayedHideSubMenus}" onclick="{openIntercom}" data-track="Right Click Menu" data-track-action="Feedback"> <span class="floating-menu_label">Send feedback</span> </li> </section> </div>',
  '',
  'class="floating-menu floating-menu--fixed floating-menu--hidden" riot-style="{`top: ${this.y}px; left: ${this.x}px;`}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants.js');

var _copyPaste = require('lib/copy-paste');

var _copyPaste2 = _interopRequireDefault(_copyPaste);

var _perspectivesUi = require('lib/perspectives-ui');

var _appUi = require('lib/app-ui');

var _fileAttachmentsUi = require('lib/file-attachments-ui');

var _menuUi = require('lib/menu-ui');

var _constants2 = require('lib/constants');

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _delayHandler = require('lib/delay-handler');

var _regionUi = require('lib/region-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;
var isMac = canvas.isMac;

canvas.rightClickMenu = this;

this.isMac = isMac;
this.x = 0;
this.y = 0;
this.isRightClickMenu = true;
this.menuName = 'right-click-menu';
this.summoned = false;
this.nodeTag = null;
this.nodeEyeball = null;
this.isBulkMenu = false;
this.singleCardMenu = false;
this.nodeTagHasChildren = false;
this.isPerspectivePointMenu = false;
this.isNodePerspectiveDotMenu = false;
this.isNodePerspectiveAnnotationMenu = false;
this.isPopoutMenu = false;
this.isFreehandMenu = false;
this.isImageMenu = false;
this.isVideoMenu = false;
this.isFileMenu = false;
this.isPdfFile = false;
this.FREE_CARD_LIMIT = _constants2.FREE_CARD_LIMIT;

this.positionSelf = _menuUi.mui.positionSelf.bind(this);

this.perspectiveColorPickerVisible = false;
this.perspectiveColors = _constants2.PERSPECTIVE_COLORS;

this.on('updated', _eventTracking2.default.listen(this.root));

this.canEdit = function () {
  if (canvas.store.access.permission === 'edit') return true;
  return false;
};

this.canComment = function () {
  var permission = canvas.store.access.permission;

  if (!canvas.isFeatureEnabled('comments')) return false;
  if (permission === 'edit' || permission === 'comment') return true;

  return false;
};

this.summon = function (_ref) {
  var x = _ref.x,
      y = _ref.y,
      nodeTag = _ref.nodeTag,
      nodeEyeball = _ref.nodeEyeball,
      nodePerspectiveDot = _ref.nodePerspectiveDot,
      nodePerspectiveAnnotation = _ref.nodePerspectiveAnnotation,
      isPopoutMenu = _ref.isPopoutMenu,
      isFreehandMenu = _ref.isFreehandMenu,
      isImageMenu = _ref.isImageMenu,
      isVideoMenu = _ref.isVideoMenu,
      isFileMenu = _ref.isFileMenu,
      isPdfFile = _ref.isPdfFile,
      isAttribute = _ref.isAttribute,
      attributeId = _ref.attributeId,
      isRegionMenu = _ref.isRegionMenu,
      isCanvas = _ref.isCanvas;

  canvas.hidePopups();
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;
  _this.hide();

  _this.x = x;
  _this.y = y;
  _this.isPopoutMenu = isPopoutMenu;
  _this.isFreehandMenu = isFreehandMenu;
  _this.isRegionMenu = isRegionMenu;
  if (isCanvas) {
    _this.isCanvas = true;
  } else if (isAttribute) {
    _this.isAttributeMenu = true;
    _this.attributeId = attributeId;
    _this.parentNodeTag = nodeTag;
  } else if (isImageMenu || isVideoMenu || isFileMenu) {
    _this.parentNodeTag = nodeTag;
    _this.isImageMenu = isImageMenu;
    _this.isVideoMenu = isVideoMenu;
    _this.isFileMenu = isFileMenu;
    _this.isPdfFile = isPdfFile;
  } else if (nodeTag) {
    _this.nodeTag = nodeTag;
    canvas.setMouseEnteredNode(_this.getActiveNodeTag());
  } else if (nodeEyeball) {
    _this.nodeEyeball = nodeEyeball;
    _this.isPerspectivePointMenu = true;
    canvas.setMouseEnteredNode(_this.nodeEyeball.nodeTag);
  } else if (nodePerspectiveDot) {
    _this.nodePerspectiveDot = nodePerspectiveDot;
    canvas.setMouseEnteredNode(_this.nodePerspectiveDot.nodeTag);
    _this.isNodePerspectiveDotMenu = true;
  } else if (nodePerspectiveAnnotation) {
    _this.nodePerspectiveAnnotation = nodePerspectiveAnnotation;
    _this.isNodePerspectiveAnnotationMenu = true;
  } else if (canvas.selectedElements.length && !_this.showSingleCardRightClickMenu()) {
    _this.isBulkMenu = true;
  }

  if (_this.nodeTag && _this.showSingleCardRightClickMenu()) {
    _this.singleCardMenu = true;
    if (nodeTag.children().length) {
      _this.nodeTagHasChildren = true;
    }
  }

  if (_this.isCanvasMenu()) {
    canvas.clearSelectedElements();
  }

  _this.summoned = true;
  _this.root.classList.remove('floating-menu--hidden');

  _this.update();

  if (_this.showLayoutOption()) {
    if (_this.tags['menu-item-layout']) {
      var layout = _this.getActiveNodeTag().instance.layoutName;
      _this.tags['menu-item-layout'].setDisplayedLayout(layout);
    }
  }

  _this.positionSelf({
    clickPosition: { x: _this.x, y: _this.y },
    selfEl: _this.refs.floatingMenuEl
  });
};

this.hide = function () {
  var nodeTag = _this.getActiveNodeTag();
  if (nodeTag) {
    nodeTag.removeHoveredState();
  }
  if (_this.nodeEyeball) {
    _this.nodeEyeball.nodeTag.removeHoveredState();
  }
  if (_this.nodePerspectiveDot) {
    _this.nodePerspectiveDot.nodeTag.removeHoveredState();
  }
  _this.summoned = false;
  _this.nodeTag = null;
  _this.nodeEyeball = null;
  _this.nodePerspectiveDot = null;
  _this.nodePerspectiveAnnotation = null;
  _this.isBulkMenu = false;
  _this.singleCardMenu = false;
  _this.nodeTagHasChildren = false;
  _this.isPopoutMenu = false;
  _this.isFreehandMenu = false;
  _this.isImageMenu = false;
  _this.isVideoMenu = false;
  _this.isFileMenu = false;
  _this.isPdfFile = false;
  _this.isPerspectivePointMenu = false;
  _this.isNodePerspectiveDotMenu = false;
  _this.isNodePerspectiveAnnotationMenu = false;
  _this.perspectiveColorPickerVisible = false;
  _this.attributeId = null;
  _this.isAttributeMenu = false;
  _this.isCanvas = false;
  if (_this.tags['menu-item-relationship-style']) _this.tags['menu-item-relationship-style'].hideSubMenu();
  if (_this.tags['menu-item-card-style']) _this.tags['menu-item-card-style'].hideSubMenu();
  _this.root.classList.add('floating-menu--hidden');

  _this.update();
};

this.isSummonedToNode = function (id) {
  if (_this.summoned && _this.nodeTag && _this.nodeTag.id == id) {
    return true;
  }
  return false;
};

this.canvasIsEmpty = function () {
  return canvas.store.getNodesSize() === 0;
};

this.openUserGuide = function (e) {
  canvas.openSidebar('user-guide');
  _this.hide();
};

this.openIntercom = function (e) {
  document.getElementById('intercom-launch-button').click();
  _this.hide();
};

this.copy = function (e) {
  if (_this.singleCardMenu) {
    canvas.setSelectedElement(_this.nodeTag, false);
  }
  canvas.copyNode(e);
  _this.hide();
};

this.cut = function (e) {
  if (_this.singleCardMenu) {
    canvas.setSelectedElement(_this.nodeTag, false);
  }
  canvas.handleCut(e);
  _this.hide();
};

this.pasteContentExists = function () {
  return _copyPaste2.default.pasteContentExists();
};

this.delayedHideSubMenus = function (e) {
  if (e) {
    e.stopPropagation();
  }
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants2.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function (e) {
  if (canvas.nodeLayoutMenuTag.fromOrigin(_this.menuName)) canvas.nodeLayoutMenuTag.hide();
  if (canvas.nodePerspectivesPanelTag.fromOrigin(_this.menuName)) canvas.nodePerspectivesPanelTag.hide();
  if (canvas.exportMenu.fromOrigin(_this.menuName)) canvas.exportMenu.hide();
  if (canvas.nodeAlignmentPanelTag.fromOrigin(_this.menuName)) canvas.nodeAlignmentPanelTag.hide();
  if (canvas.linkDirectionMenu.fromOrigin(_this.menuName)) canvas.linkDirectionMenu.hide();
  if (canvas.imageSizeMenu.fromOrigin(_this.menuName)) canvas.imageSizeMenu.hide();
  if (canvas.nodeAttributeEditor.fromOrigin(_this.menuName)) canvas.nodeAttributeEditor.hide();

  _this.perspectiveColorPickerVisible = false;
  if (_this.tags['menu-item-relationship-style']) _this.tags['menu-item-relationship-style'].hideSubMenu();
  if (_this.tags['menu-item-card-style']) _this.tags['menu-item-card-style'].hideSubMenu();
  _this.update();
};

this.getActiveNodeTag = function () {
  if (_this.nodeTag) {
    return _this.nodeTag;
  }
  var nodeIds = _this.getSelectedNodeIds();
  if (nodeIds && nodeIds.length == 1) {
    return canvas.nodeTags[nodeIds[0]];
  }
};

this.getActiveLinkTag = function () {
  if (_this.linkTag) {
    return _this.linkTag;
  }
  var linkIds = _this.getSelectedLinkIds();
  if (linkIds && linkIds.length == 1) {
    return canvas.linkTags[linkIds[0]];
  }
};

// return the list of node ids that the current right click menu will operate on
this.getSelectedNodeIds = function () {
  if (_this.nodeTag) {

    // if there's a selection, and the nodeTag is part of it, return the whole selection
    if (canvas.getSelectedNodes().length && canvas.getSelectedNodes().find(function (n) {
      return n.id == _this.nodeTag.id;
    })) {
      return canvas.getSelectedNodes().map(function (n) {
        return n.id;
      });
    }
    // if the current node isn't part of a selection, just return it by itself
    return [_this.nodeTag.id];
  } else if (canvas.getSelectedNodes().length) {
    return canvas.getSelectedNodes().map(function (n) {
      return n.id;
    });
  }
};

this.getSelectedLinkIds = function () {
  if (canvas.getSelectedLinks().length) {
    return canvas.getSelectedLinks().map(function (l) {
      return l.id;
    });
  } else if (_this.linkTag) {
    return [_this.linkTag.id];
  }
};

this.getSelectedRegionIds = function () {
  return _regionUi.regionUI.getSelectedRegionIdsArray();
};

this.openImageSizeMenu = function (e) {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'imagesize',
    delay: _constants2.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus(e);
      canvas.imageSizeMenu.summon({
        referenceEl: _this.refs.imageSizeMenuItem,
        nodeTag: _this.parentNodeTag,
        positionToLeft: _this.positionSubToLeft,
        origin: _this.menuName
      });
    }
  });
};

this.openEditImage = function (e) {
  e.stopPropagation();
  canvas.imageModal.triggerEdit(_this.parentNodeTag.id);
  _this.hide();
};

this.deleteImage = function () {
  _fileAttachmentsUi.fui.removeImage(_this.parentNodeTag.id);
  _this.hide();
};

this.viewPerspective = function () {
  if (!_this.nodeEyeball) {
    return;
  }
  _perspectivesUi.pui.setActivePerspective(_this.nodeEyeball.pointPerspective, true);
  _this.hide();
};

this.exitPerspective = function () {
  if (!_this.nodeEyeball) {
    return;
  }
  _perspectivesUi.pui.unsetActivePerspective(_this.nodeEyeball.pointPerspective);
  _this.hide();
};

this.removePerspective = function () {
  if (!_this.nodeEyeball) {
    return;
  }
  _perspectivesUi.pui.deletePerspective(_this.nodeEyeball.pointPerspective.id);
  _perspectivesUi.pui.refreshPerspectiveLists();
  _this.nodeEyeball.nodeTag.update();
  _this.nodeEyeball.nodeTag.topLevelParentTag().rediscoverLinkPositions();
  _this.hide();
};

this.getPerspectiveColor = function () {
  var _getSelectedPerspecti = _this.getSelectedPerspectiveDetails(),
      perspective = _getSelectedPerspecti.perspective;

  return perspective.color;
};

this.colorPickerPosition = function (type) {
  if (_this.positionSubToLeft && type == 'link') {
    return 'top: 0px; left: -253px;';
  }
  if (_this.positionSubToLeft && type == 'card') {
    return 'top: 0px; left: -233px;';
  }
  if (_this.positionSubToLeft && type == 'perspective') {
    return 'top: 0px; left: -120px;';
  }
  return 'top: 0px; left: 100%';
};

this.summonPerspectiveColorPicker = function (e) {
  e.stopPropagation();
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'perspectivecolor',
    delay: _constants2.MENU_OPEN_DELAY,
    callback: function callback() {
      if (_this.perspectiveColorPickerVisible) return;
      _this.hideSubMenus(e);
      _this.perspectiveColorPickerVisible = true;
      _this.update();
    }
  });
};

this.setPerspectiveColor = function (color) {
  var perspectiveUUID = _this.nodeEyeball.pointPerspective.id;
  _perspectivesUi.pui.editPerspectiveColor({
    color: color,
    perspectiveUUID: perspectiveUUID
  });
  _this.update();
};

this.editPerspectiveAnnotation = function (e) {
  e.stopPropagation();

  var _getSelectedPerspecti2 = _this.getSelectedPerspectiveDetails(),
      perspective = _getSelectedPerspecti2.perspective,
      nodeId = _getSelectedPerspecti2.nodeId;

  var nodeTag = canvas.nodeTags[nodeId];
  var dot = nodeTag.getPerspectiveDots().getDot(perspective.id);
  var annotationTag = dot.getAnnotationTag();
  annotationTag.unsetHovered();
  annotationTag.openAnnotation({ setFocus: true });
  _this.hide();
};

this.hidePerspectiveAnnotation = function () {
  var _getSelectedPerspecti3 = _this.getSelectedPerspectiveDetails(),
      perspective = _getSelectedPerspecti3.perspective,
      nodeId = _getSelectedPerspecti3.nodeId;

  var nodeTag = canvas.nodeTags[nodeId];
  var dot = nodeTag.getPerspectiveDots().getDot(perspective.id);
  dot.closeAnnotation();
  _this.hide();
};

this.deletePerspectiveAnnotation = function () {
  var _getSelectedPerspecti4 = _this.getSelectedPerspectiveDetails(),
      perspective = _getSelectedPerspecti4.perspective,
      nodeId = _getSelectedPerspecti4.nodeId;

  _perspectivesUi.pui.deleteAnnotation(perspective, nodeId);
  _this.hide();
};

this.getSelectedPerspectiveDetails = function () {
  var perspective = void 0;
  var nodeId = void 0;
  if (_this.nodeEyeball) {
    perspective = canvas.store.getPerspective(_this.nodeEyeball.pointPerspective.id);
    nodeId = _this.nodeEyeball.nodeTag.id;
  } else if (_this.nodePerspectiveDot) {
    perspective = canvas.store.getPerspective(_this.nodePerspectiveDot.id);
    nodeId = _this.nodePerspectiveDot.nodeId;
  } else if (_this.nodePerspectiveAnnotation) {
    perspective = canvas.store.getPerspective(_this.nodePerspectiveAnnotation.perspective.id);
    nodeId = _this.nodePerspectiveAnnotation.nodeTag.id;
  }
  return { perspective: perspective, nodeId: nodeId };
};

this.removeFromPerspectiveView = function () {
  var _getSelectedPerspecti5 = _this.getSelectedPerspectiveDetails(),
      perspective = _getSelectedPerspecti5.perspective,
      nodeId = _getSelectedPerspecti5.nodeId;

  var nodeTag = canvas.nodeTags[nodeId];
  _perspectivesUi.pui.removeNodeFromPerspective(perspective, nodeTag);
  _this.hide();
};

this.isCanvasMenu = function () {
  return _this.isCanvas;
};

this.isCanvasOrNodeMenu = function () {
  return _this.singleCardMenu || _this.getActiveNodeTag() || _this.isFreehandMenu || _this.isPopoutMenu || !_this.isBulkMenu && !_this.isPerspectivePointMenu && !_this.isNodePerspectiveDotMenu && !_this.isNodePerspectiveAnnotationMenu && !_this.isImageMenu && !_this.isVideoMenu && !_this.isFileMenu && !_this.isAttributeMenu;
};

this.isAnyPerspectiveMenu = function () {
  return _this.isPerspectivePointMenu || _this.isNodePerspectiveDotMenu || _this.isNodePerspectiveAnnotationMenu;
};

this.perspectiveIsActive = function () {
  if (!_this.nodeEyeball) {
    return;
  }
  return _this.nodeEyeball.pointIsActive();
};

this.showPartsOptions = function () {
  if (_this.isPopoutMenu && _this.singleCardMenu) {
    return true;
  }
};

this.showArrangeOption = function () {
  if (_this.singleCardMenu || _this.isFreehandMenu || _this.showPartsOptions()) {
    return false;
  }

  if (_this.showCardOptions() && canvas.getSelectedNodes().length > 1) {
    return true;
  }
};

this.showCardOptions = function () {
  if (!_this.canEdit()) return false;

  if (_this.isPopoutMenu || _this.isImageMenu || _this.isVideoMenu || _this.isFileMenu) {
    return false;
  }
  if (_this.isAnyPerspectiveMenu()) {
    return false;
  }
  if (canvas.getSelectedNodes().length || _this.nodeTag) {
    return true;
  }
};

this.showSelectAll = function () {
  if (!_this.canEdit()) return false;
  return _this.isCanvasMenu() && !_this.canvasIsEmpty() || _this.isFreehandMenu || _this.isPopoutMenu || _this.singleCardMenu && _this.nodeTagHasChildren;
};

this.showCopy = function () {
  return _this.showCardOptions() && !_this.showPartsOptions() && !_this.isFreehandMenu;
};

this.showCut = this.showCopy;

this.showPaste = function () {
  return _this.isCanvasOrNodeMenu() && _this.pasteContentExists() && _this.canEdit();
};

this.showSingleCardRightClickMenu = function () {
  var nodeIds = _this.getSelectedNodeIds();
  if (_this.nodeTag) {
    var selectedNodes = canvas.getSelectedNodes();
    if (selectedNodes.find(function (n) {
      return n.id == _this.nodeTag.id;
    })) {
      // show bulk menu if current node is part of a selection
      if (selectedNodes.length == 1) {
        return true;
      } else {
        return false;
      }
    }
    // if we clicked a nodeTag and other elements are selected, then just show the 1 card menu
    return true;
  }
  return false;
};

this.showPopPartsOption = function () {
  var nodeTag = _this.getActiveNodeTag();
  if (_this.singleCardMenu && nodeTag.instance.children().length) {
    return true;
  }
  return false;
};

this.showPopIn = _menuUi.mui.showPopIn.bind(this);
this.showPopOut = _menuUi.mui.showPopOut.bind(this);

this.showGroupSelection = function () {
  if (_this.singleCardMenu) {
    return false;
  }
  if (!_this.showCardOptions()) {
    return false;
  }
  if (_this.showPartsOptions()) {
    return false;
  }
  if (_this.isFreehandMenu) {
    return false;
  }
  if (canvas.getSelectedNodes().length > 1) {
    return true;
  }
  return false;
};

this.showDetachRelationshipCard = function () {
  var nodeIds = _this.getSelectedNodeIds();
  if (!nodeIds || nodeIds.length !== 1) {
    return false;
  }
  var node = canvas.store.getNode(nodeIds[0]);
  if (node.link()) {
    return true;
  }
  return false;
};

this.showDetachPart = function () {
  var nodeIds = _this.getSelectedNodeIds();
  if (!nodeIds || nodeIds.length == 0) {
    return false;
  }
  // if selected cards are part of another card, or if they have children themselves, show 'detach parts'
  return nodeIds.some(function (id) {
    var node = canvas.store.getNode(id);
    if (node.parentId) {
      return true;
    }
    return false;
  });
};

this.showUngroupSystem = function () {
  var nodeIds = _this.getSelectedNodeIds();
  if (!nodeIds || nodeIds.length == 0) {
    return false;
  }
  // if selected cards are part of another card, or if they have children themselves, show 'detach parts'
  return nodeIds.some(function (id) {
    var node = canvas.store.getNode(id);
    if (node.children().length) {
      return true;
    }
    return false;
  });
};

this.showLayoutOption = function () {
  if (_this.singleCardMenu || _this.getActiveNodeTag() && _this.getActiveNodeTag().instance.children().length || _this.isPopoutMenu || _this.isFreehandMenu) {
    return true;
  }
};

this.showRelationshipOptions = function () {
  if (_this.nodeTag || _this.isImageMenu || _this.isVideoMenu || _this.isFileMenu) {
    return false;
  }
  if (canvas.getSelectedLinks().length || _this.linkTag) {
    return true;
  }
  return false;
};

this.showCreateRelationshipCard = function () {
  if (!_this.showRelationshipOptions()) return false;

  var linkTag = _this.getActiveLinkTag();
  if (linkTag && !linkTag.instance.linkNode()) return true;
  return false;
};

this.hasPerspectiveAnnotation = function () {
  if (_this.nodePerspectiveDot) {
    return _this.nodePerspectiveDot.hasPerspectiveAnnotation();
  }
  if (_this.nodePerspectiveAnnotation) {
    return _this.nodePerspectiveAnnotation._getAnnotation();
  }
};

this.isAnnotationShowing = function () {
  if (_this.nodePerspectiveAnnotation) {
    return _this.nodePerspectiveAnnotation.isActive();
  }
  if (_this.nodePerspectiveDot) {
    return _this.nodePerspectiveDot.getAnnotationTag().isActive();
  }
};

this.openPerspectivesOnboarding = function () {
  canvas.openSidebar('user-guide');
  canvas.userGuideTag.openItem('what-is-p');
  _this.hide();
};

this.downloadFile = function (e) {
  e.stopPropagation();
  window.open(_fileAttachmentsUi.fui.getFileUrl(_this.parentNodeTag.id), '_blank');
  _this.hide();
};

this.openLightbox = function (e) {
  e.stopPropagation();
  canvas.lightbox.show(_this.parentNodeTag.instance.attachedFile.file_url, { imageType: 'pdf' });
};

this.showPaymentModal = function (e) {
  e.preventDefault();
  canvas.showPaymentModal();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('right-click-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/right-click-menu.html
// module id = 676
// module chunks = 0